"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomlySelectStrings = exports.getSquareChoiceButtonSX = exports.getTextChoiceButtonSX = exports.getTheme = void 0;
const gameplay_components_1 = require("../gameplay_components");
const theme_1 = require("../theme");
const gameplay_1 = require("../gameplay");
const shuffle_array_1 = __importDefault(require("shuffle-array"));
function getTheme(gameplayStyle) {
    switch (gameplayStyle) {
        case gameplay_1.GameplayStyle.PopStudy:
            return theme_1.popStudyGameplayTheme;
        case gameplay_1.GameplayStyle.PopQuiz:
            return theme_1.popQuizGameplayTheme;
        case gameplay_1.GameplayStyle.PopQuizHost:
            return theme_1.popQuizHostGameplayTheme;
    }
}
exports.getTheme = getTheme;
function getTextChoiceButtonSX(gameplayStyle, presentation, theme) {
    let styles = {
        // flex: {
        //   xs: undefined,
        //   sm: 1,
        // },
        height: '54px', // todo: does not work
        width: {
            xs: '100%',
            sm: '290px',
        },
        // width: '100%',
        fontFamily: 'Effra',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '26px',
        letterSpacing: '0.46px',
    };
    switch (presentation) {
        case gameplay_components_1.GameplayChoicePresentation.Default:
            styles = {
                ...styles,
                color: gameplayStyle === gameplay_1.GameplayStyle.PopStudy
                    ? theme.palette.primary.main
                    : theme.palette.primary.contrastText,
                backgroundColor: undefined,
                borderColor: gameplayStyle === gameplay_1.GameplayStyle.PopStudy
                    ? theme.palette.primary.main
                    : theme.palette.primary.contrastText,
            };
            break;
        case gameplay_components_1.GameplayChoicePresentation.Pending:
            styles = {
                ...styles,
                '&:disabled': {
                    color: '#FFFFFF',
                },
            };
            break;
        case gameplay_components_1.GameplayChoicePresentation.Correct:
            styles = {
                ...styles,
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.success.main,
                '&:disabled': {
                    color: theme.palette.primary.contrastText,
                    backgroundColor: theme.palette.success.main,
                },
            };
            break;
        case gameplay_components_1.GameplayChoicePresentation.Incorrect:
            styles = {
                ...styles,
                '&:disabled': {
                    color: '#FFFFFF',
                },
            };
            break;
        case gameplay_components_1.GameplayChoicePresentation.Eliminated:
            styles = {
                ...styles,
                '&:disabled': {
                    color: gameplayStyle === gameplay_1.GameplayStyle.PopStudy
                        ? theme.palette.primary.main
                        : theme.palette.primary.contrastText,
                    backgroundColor: undefined,
                    borderColor: gameplayStyle === gameplay_1.GameplayStyle.PopStudy
                        ? theme.palette.primary.main
                        : theme.palette.primary.contrastText,
                },
            };
            break;
        default:
            break;
    }
    return styles;
}
exports.getTextChoiceButtonSX = getTextChoiceButtonSX;
function getSquareChoiceButtonSX(gameplayStyle, presentation, theme) {
    let styles = {
        borderRadius: '0.75rem',
        borderWidth: '6.971px',
        borderStyle: 'solid',
        width: {
            xs: '148px',
            sm: '200px',
        },
        height: {
            xs: '148px',
            sm: '200px',
        },
    };
    switch (presentation) {
        case gameplay_components_1.GameplayChoicePresentation.Default:
            styles = {
                ...styles,
                color: gameplayStyle === gameplay_1.GameplayStyle.PopStudy
                    ? theme.palette.text.primary
                    : theme.palette.primary.contrastText,
                borderColor: gameplayStyle === gameplay_1.GameplayStyle.PopStudy ? '#0000003D' : '#FFFFFF3D',
                // the following code will make mui use xs style only. no idea why
                // [theme.breakpoints.up('sm')]: {
                //   '&:hover': {
                //     color:
                //       gameplayStyle === GameplayStyle.PopStudy ? '#000000' : '#FFFFFF',
                //     borderColor: theme.palette.primary.main,
                //   },
                // },
            };
            break;
        case gameplay_components_1.GameplayChoicePresentation.Pending:
            styles = {
                ...styles,
                color: gameplayStyle === gameplay_1.GameplayStyle.PopStudy
                    ? theme.palette.text.primary
                    : theme.palette.primary.contrastText,
                borderColor: theme.palette.primary.dark,
                '&:disabled': {
                    color: gameplayStyle === gameplay_1.GameplayStyle.PopStudy ? '#000000' : '#FFFFFF',
                },
            };
            break;
        case gameplay_components_1.GameplayChoicePresentation.Correct:
            styles = {
                ...styles,
                color: gameplayStyle === gameplay_1.GameplayStyle.PopStudy
                    ? theme.palette.text.primary
                    : theme.palette.primary.contrastText,
                borderColor: theme.palette.success.main,
                '&:disabled': {
                    color: gameplayStyle === gameplay_1.GameplayStyle.PopStudy ? '#000000' : '#FFFFFF',
                },
            };
            break;
        case gameplay_components_1.GameplayChoicePresentation.Incorrect:
            styles = {
                ...styles,
                color: gameplayStyle === gameplay_1.GameplayStyle.PopStudy
                    ? theme.palette.text.primary
                    : theme.palette.primary.contrastText,
                borderColor: theme.palette.error.main,
                '&:disabled': {
                    color: gameplayStyle === gameplay_1.GameplayStyle.PopStudy ? '#000000' : '#FFFFFF',
                },
            };
            break;
        case gameplay_components_1.GameplayChoicePresentation.Eliminated:
            styles = {
                ...styles,
                color: gameplayStyle === gameplay_1.GameplayStyle.PopStudy
                    ? theme.palette.text.primary
                    : theme.palette.primary.contrastText,
                borderColor: '#FFFFFF3D',
                '&:disabled': {
                    color: gameplayStyle === gameplay_1.GameplayStyle.PopStudy ? '#000000' : '#FFFFFF',
                },
            };
            break;
        default:
            break;
    }
    return styles;
}
exports.getSquareChoiceButtonSX = getSquareChoiceButtonSX;
function randomlySelectStrings(array, mustInclude, count) {
    if (count === 0) {
        return [];
    }
    if (array.length === 0) {
        return [];
    }
    const set = new Set(array);
    for (const include of mustInclude) {
        if (!set.has(include)) {
            return [];
        }
    }
    if (array.length < count) {
        return [];
    }
    else if (array.length === count) {
        const mutable = [...array];
        (0, shuffle_array_1.default)(mutable);
        return mutable;
    }
    const arr = [];
    arr.push(...mustInclude);
    const allLeftover = array.filter(str => !arr.includes(str));
    (0, shuffle_array_1.default)(allLeftover);
    arr.push(...allLeftover);
    const result = arr.slice(0, count);
    (0, shuffle_array_1.default)(result);
    return result;
}
exports.randomlySelectStrings = randomlySelectStrings;
